import {
  SubscriptionTypes,
  getCurrentSubscription
} from 'entities/subscription';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

const SubscriptionBadgeIOS = ({ subscriptions }) => {
  const { t } = useTranslation();

  // Current subscription is valid
  if (!!subscriptions.receipt && !subscriptions.receipt?.isExpired) {
    return null;
  }

  // Subscription is Forever
  if (subscriptions?.receipt?.plan === SubscriptionTypes.forever) {
    return null;
  }

  return (
    <div className="subscription-badge">
      <Link to="/upgrade" className="ui button">
        {t('buttons.btn_upgrade')}
      </Link>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  subscriptions: state.subscriptions
});

export default connect(mapStateToProps)(SubscriptionBadgeIOS);
